import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function NotActiveFolder(): React.ReactElement {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.4118 1.91153H9.10235L7.64647 0.180349C7.60301 0.128114 7.53789 0.0988198 7.47 0.100937H1.58824C0.707824 0.109673 -0.00101362 0.826364 1.08806e-06 1.70682V12.2951C-4.30296e-05 13.1748 0.70853 13.8905 1.58824 13.8992H16.4118C17.2915 13.8905 18 13.1748 18 12.2951V3.51564C18 2.63589 17.2915 1.92026 16.4118 1.91153Z" />
    </svg>
  );
}
